import { Component, Inject } from '@angular/core';

import get from 'lodash/get';

import { ISitemap, SITEMAP } from 'pbc.angular';
import { ISorterConfig } from 'pbc.types';

import { KundenQuerySorterConfig } from 'fa-kt.types';
import { KundenService } from '../service';

@Component({
  selector: 'fa-kt-kunden-sorter',
  templateUrl: './kunden-sorter.component.html',
  styleUrls: ['./kunden-sorter.component.css'],
})
export class KundenSorterComponent {
  public KundenSorterConfig: ISorterConfig;

  constructor(
    @Inject(SITEMAP) private sitemap: ISitemap,
    public kunden: KundenService,
  ) {
    this.KundenSorterConfig = KundenQuerySorterConfig.map((filter) => ({ ...filter, title: get(sitemap, filter.title, filter.title) as string }));
    /* << update    */
    /*    update >> */
  }
}
